import { render } from "./SidebarItem.vue?vue&type=template&id=2d2bbdc2"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2d2bbdc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d2bbdc2', script)) {
    api.reload('2d2bbdc2', script)
  }
  
  module.hot.accept("./SidebarItem.vue?vue&type=template&id=2d2bbdc2", () => {
    api.rerender('2d2bbdc2', render)
  })

}

script.__file = "src/layout/components/Sidebar/SidebarItem.vue"

export default script